export const setPaidRecords = {
  SET_PAID_RECORDS(state, payload) {
    state.paidRecords = payload;
  }
};
